import { Injectable } from '@angular/core';
import { EMPTY, map } from 'rxjs';
import { GetByEmailRequest } from '../../../../../backend/src/core/request-response';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { UserClerkGate } from './../../../../../backend/src/core/user-clerk/user-clerk.gate';
import { LambdaService } from './../../shared/core/lambda.service';

@Injectable({
  providedIn: 'root',
})
export class UserClerkCallBackendService {
  constructor(private lambdaService: LambdaService) {}

  private _resourceName = ResourceName.userClerk;

  isAccessTokenValid$(accessToken: string) {
    return this.lambdaService
      .run$(ResourceName.userClerk, UserClerkGate.actions.isAccessTokenValid, { accessToken })
      .pipe(
        map((data) => {
          return data.isSuccess;
        })
      );
  }

  getSignInTokens$() {
    return this.lambdaService.run$(this._resourceName, UserClerkGate.actions.getSignInTokens).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getUserListByEmailList$(emailList: string[]) {
    const request = {
      emailList,
    };
    return this.lambdaService.run$(this._resourceName, UserClerkGate.actions.getUserListByEmailList, request);
  }

  getByEmail$(email: string) {
    if (!email) {
      return EMPTY;
    }
    const request: GetByEmailRequest = {
      email,
    };

    return this.lambdaService.run$(this._resourceName, UserClerkGate.actions.getByEmail, request);
  }
}
